import { ILeagueGroupDictionaryApi } from '@/types';

export class LeagueGroupDictionaryItem {
    id: number;
    name: string;
    customLeagueIds: number[];

    constructor(data: ILeagueGroupDictionaryApi) {
        this.id = data.id;
        this.name = data.name;
        if (data.league_group_ids) {
            this.customLeagueIds = data.league_group_ids.split(',').map(Number);
        } else {
            this.customLeagueIds = [];
        }
    }
}
